import { useCallback, useEffect, useState } from 'react';

const getQuery = () => {
    if (typeof window !== 'undefined') {
        return new URLSearchParams(window.location.search);
    }
    return new URLSearchParams();
};

const getQueryStringVal = (key) => {
    return getQuery().get(key);
};


const useQueryParam = (key, defaultVal) => {
    const [query, setQuery] = useState(getQueryStringVal(key) || defaultVal);

    const updateUrl = useCallback((newVal) => {
        const nNewVal = newVal?.toString() ?? '';
        setQuery(newVal);

        const nQuery = getQuery();

        if (nNewVal.trim() !== '') {
            nQuery.set(key, nNewVal);
        } else {
            nQuery.delete(key);
        }

        if (typeof window !== 'undefined') {
            const { protocol, pathname, host } = window.location;
            const newUrl = `${protocol}//${host}${pathname}?${nQuery.toString()}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [key]);

    useEffect(() => {
        const onPopState = () => {
            const newVal = getQueryStringVal(key) || defaultVal;
            setQuery(newVal);
        };

        window.addEventListener('urlchange', onPopState);

        return () => {
            window.removeEventListener('urlchange', onPopState);
        };
    }, [key, defaultVal]);

    return [query, updateUrl];
};

export default useQueryParam;